import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, } from '@angular/core';

@Component({
    selector: 'app-search-input',
    templateUrl: './search-input.component.html',
    styleUrl: './search-input.component.scss',
    standalone: false
})
export class SearchInputComponent implements OnChanges {
  value:string = '';
  @Input() placeholder: string ='Search';
  @Output() search = new EventEmitter<string>();
  @Input() searchText: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['searchText']) {
      this.value = changes['searchText'].currentValue ?? '';
    }
  }

  onSearchClick(){
    this.search.emit(this.value);
  }

  clear(){
    this.value ='';
  }
}
